/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MarketingDataDto } from '../../models/marketing-data-dto';
import { MarketingDataViewModel } from '../../models/marketing-data-view-model';

export interface CreateMarketingDataToMerchant$Params {
  merchantId: string;
      body: MarketingDataDto
}

export function createMarketingDataToMerchant(http: HttpClient, rootUrl: string, params: CreateMarketingDataToMerchant$Params, context?: HttpContext): Observable<StrictHttpResponse<MarketingDataViewModel>> {
  const rb = new RequestBuilder(rootUrl, createMarketingDataToMerchant.PATH, 'post');
  if (params) {
    rb.path('merchantId', params.merchantId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MarketingDataViewModel>;
    })
  );
}

createMarketingDataToMerchant.PATH = '/merchants/{merchantId}/marketing-data';
